<template>
    <div class="tle-row">
        <div class="tle-col two-fifth">
            <p class="label main_color_text">
                <el-textarea
                    :parent_data="active_study.etudeData.dynamique_territoriale"
                    property="label_objectifs_plh"
                    :editable="true"
                    placeholder="choix du périmètre géographique"
                />
            </p>
            <el-table :table="table_objectifs_plh" :editable="true" condensed></el-table>
            <!-- <p class="source">Source : INSEE (2006-2015), INSEE DGI (FILOSOFI 2015 retraités ADEQUATION), Profils de marché ADEQUATION 2015</p> -->
        </div>
        <div class="tle-col three-fifth">
            <p class="label main_color_text">Dynamisme sociodémographique</p>
            <el-progress-slider
                :parent_data="active_study.etudeData.dynamique_territoriale"
                property="dynamisme_sociodemographique"
                :max="10"
                :editable="true"
                :labels="[ 'Faible', 'Élevé' ]"
            />
            <div style="height: 8px" />
            <!-- <br> -->
            <p class="label main_color_text">Dynamisme de la construction globale de l'Agglomération</p>
            <p class="label-info">En nombre de logements pour 1000 habitants, période {{parameters.sitadel_annee_min_sitadel}}-{{parameters.sitadel_annee_max_sitadel}}</p>
            <el-mean-slider
                :parent_data="dynamique_logements.data"
                property="ratiologt_1000hab"
                :max="dynamique_logements.max" :show_max="false"
                :values="dynamique_logements.values"
                :labels="dynamique_logements.labels"
                :rootComponent="dynamique_logements"
                :editable="dynamique_logements.editable"
            />

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "section-dynamique-territoriale-end",
	mixins: [PageMixin],
	props: {
		index: { default: 1 },
		main_color: { default: "dark_blue" },
	},
	computed: {
		...mapGetters(["active_study", "editor", "etude_data","app_parameters"]),
		parameters () {
			try {
				return this.active_study.qlikData.parameters.lexiqueParam;
			} catch (e) {
				return false;
			}
		},
		table_objectifs_plh: function () {
			const table = { head: [], body: [], config: {
				cols_width: [ 66, 34 ]
			} };
			const parent = this.active_study.etudeData.dynamique_territoriale;

			table.body.push([
				{ value: "Total lgts/an", },
				{ parent_data: parent, property: "total_logements_annuel", format: "number" , editable: true}
			]);
			table.body.push([
				{ value: "dont locatif social" },
				{ parent_data: parent, property: "total_logements_locatif_social", format: "number", editable: true, }
			]);
			table.body.push([
				{ value: "dont PLS" },
				{ parent_data: parent, property: "total_logements_pls", format: "number", editable: true, }
			]);
			table.body.push([
				{ value: "dont locatif interm." },
				{ parent_data: parent, property: "total_logements_locatif_intermediaire", format: "number", editable: true, }
			]);

			return table;
		},
        
		dynamique_logements: function () {
			const dynamique = {};

			let component = this.active_study.qlikData.component.find((component) => {
				return component.name == "dynamique construction globale" || component.id == "3.2";
			});

			try{
				//todelete : switch mode error/nominal (false => error case)
				//component.valid = false;
				//throw "il y a une erreur"


				// if an error is detectd in back => set componenet from default_component
				if (component.valid == false){
					//get error_message from component
					// dynamique.error_message="[BACK] : "+component.errorMessage;
					dynamique.error_message = "Donnée non disponible";
					//get defualt component
					component = this.app_parameters.default_components.find((component) => {
						return component.name == "dynamique construction globale" || component.id == "3.2";
					});
					dynamique.error = true;
				}else{
					dynamique.labels = component.content.epci.header.labels;
					dynamique.values = component.content.epci.header.values;
					dynamique.max = component.content.epci.header.max;
					dynamique.data = {"ratiologt_1000hab": component.content.epci.data.value};
					dynamique.editable = false;
				}
			}catch (error){

				dynamique.labels = [];
				dynamique.values = [];
				dynamique.max = "13";
				dynamique.data = {"ratiologt_1000hab": "0"};

				dynamique.error = true;
				//dynamique.error_message="[FRONT] : Une erreur est survenue veuillez contacter un administrateur!  : "+error;
				dynamique.error_message= "Donnée non disponible";
			}

			return dynamique;
		},
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/css/app'
@import '../../../../../assets/css/page'

.error-container
    display flex
    justify-content center
    align-items center
    z-index: 10000
    position absolute
    top 0
    left 0
    width 100% !important
    height 100% !important
    background-color black
    opacity 0.8
    color red
    text-align center
    border-style solid
    border-width 2px
    border-color red
    // vertical-align: middle
    // min-height 10em
    // display table
    // .error-content
    // 	display table-cell
    // 	vertical-align middle

input[type='radio']
    vertical-align baseline
    padding 4px
    margin 4px
    color lighten(purple, 85%)

input[type='radio'] + label
    margin-left 4px

label
    display inline-block
    text-transform uppercase
    font-size 10px
    font-weight 500

input[type='range']
    display inline-block
    width 75%

.value
    float right
    width 25%
    padding 0 0 0 8px
    font-weight 500
    text-align center
    white-space nowrap

#quartier_selector
    width 220px
</style>
